export default __webpack_public_path__ + "static/media/grity-power-bg.e92433d8.jpeg";